he.footer.init = function () {
    this.backToTop();
};

he.footer.backToTop = function () {
    var button = document.getElementById('back-to-top');

    $(button).click(function (e) {
        e.preventDefault();

        $('html, body').animate({'scrollTop': '0px'});
    });
};